import { render, staticRenderFns } from "./MyOrdersList.vue?vue&type=template&id=ea0c9ecc&"
import script from "./MyOrdersList.vue?vue&type=script&lang=js&"
export * from "./MyOrdersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports